module.exports = __webpack_public_path__ + "images/998fcf740df925e40b16a11446dd926f-IMG_8153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8153.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8153.jpg
// module chunks = 0